import Client from '../axios-client';

const resource = '/import/importOperation';

export default {
  getGrid(parameters, payload) {
    return Client.get(`${resource}/grid` + parameters, payload);
  },
};
